<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid >
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar dark color="primary">
								<v-toolbar-title>Reset Password</v-toolbar-title>
							</v-toolbar>
							<v-card-text>
								<v-text-field id="password" prepend-icon="fas fa-lock"
									:append-icon="pwVisible ? 'far fa-eye' : 'far fa-eye-slash'"
									:type="pwVisible ? 'text' : 'password'"
									@click:append="pwVisible = !pwVisible"
									v-validate="'required'" :error-messages="errors.collect('password')" required
									name="password" label="Password" v-model="password"></v-text-field>
								<v-alert :value="serverDown" type="error">
									Server unavailable
								</v-alert>
								<v-alert :value="invalid" type="warning">
									Invalid reset link
								</v-alert>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="reset" :loading="resetting"
									:disabled="resetting || errors.any()">Reset</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
import analysisApi from "../analysisApi";

export default {
	data() {
		return {
			password: null,
			resetting: false,
			invalid: false,
			serverDown: false,
			pwVisible: false,
		};
	},
	methods: {
		reset() {
			this.resetting = true;
			this.invalid = false;
			this.serverDown = false;
			analysisApi.resetPassword({ password: this.password, token: this.$route.params.token })
				.then(() => {
					this.$router.push({ name: "login" });
				})
				.catch(() => {
					this.resetting = false;
					this.invalid = true;
				});
		},
	},
};
</script>
